import { render } from "./qcInspectionList.vue?vue&type=template&id=32ee38aa"
import script from "./qcInspectionList.vue?vue&type=script&lang=js"
export * from "./qcInspectionList.vue?vue&type=script&lang=js"

import "./qcInspectionList.vue?vue&type=style&index=0&id=32ee38aa&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__